export enum VirtualRedTagNotificationChannel {
    email = 'Email',
    text = 'Text',
}

// Route names owned by the notification screens. The values are the router's route
// names, so they must match the entries in src/router/index.ts.
export enum VirtualRedTagNotificationRoute {
    method = 'VirtualRedTagNotificationMethod',
    contact = 'VirtualRedTagNotificationContact',
    confirmed = 'VirtualRedTagNotificationConfirmed',
}

// Query params the notification screens pass to each other. They are part of the URL,
// so the values must stay as they are for a refresh or a bookmark to keep working.
export enum VirtualRedTagNotificationQuery {
    assessmentId = 'assessmentId',
    method = 'method',
    trailerAlreadyInShop = 'trailerAlreadyInShop',
}

// How a boolean query param is written to, and read from, the URL.
export const VIRTUAL_RED_TAG_QUERY_TRUE = 'true';

// What the Contact screen does about a failed save.
export enum VirtualRedTagNotificationErrorKind {
    // Pressing Confirm again cannot help (the red tag was rejected, or the session is
    // gone), so the form ends and only the way out is offered.
    deadEnd = 'DeadEnd',
    // The driver can fix it by editing the contact, or try the same request again.
    retryable = 'Retryable',
}

// The HTTP statuses the Contact screen tells apart.
export enum VirtualRedTagNotificationHttpStatus {
    badRequest = 400,
    unauthorized = 401,
    forbidden = 403,
    notFound = 404,
}

export type VirtualRedTagNotificationPreferenceResponse = {
    // True when the trailer was already in Shop at opt-in, so no "moved to Shop"
    // message will ever be sent.
    trailerAlreadyInShop: boolean;
};

export type VirtualRedTagNotificationPreferenceRequest = {
    assessmentId: string;
    notificationMethod: VirtualRedTagNotificationChannel;
    contactValue: string;
};
